export const localhostApi = 'https://void'; 
